<template>
  <div class="bg-gray-300 rounded-md animate-pulse"></div>
</template>
